import React from "react";

import { useTranslation } from "react-i18next";

import { FormFileInput } from "@/uiKit/molecules/form/FormFileInput.tsx";

type PatientInfo = {
  givenName: string;
  familyName: string;
};

export type ReferralLetterFormFieldProps = {
  patientInfo: PatientInfo;
  name?: string;
  className?: string;
};

export const ReferralLetterFormField: React.FC<ReferralLetterFormFieldProps> = ({
  patientInfo,
  name = "referralLetterAttachment",
  className,
}) => {
  const { t } = useTranslation();

  return (
    <FormFileInput
      id="referral-letter-form-field"
      name={name}
      label={t("diabetesForms.referralLetter")}
      uploadLabel={t("diabetesForms.uploadReferralLetter")}
      fileType="referral_letter"
      reserveErrorSpace
      patientInfo={patientInfo}
      className={className}
    />
  );
};
